import { render, staticRenderFns } from "./AddDykProductDialog.vue?vue&type=template&id=f36fa8d8&"
import script from "./AddDykProductDialog.vue?vue&type=script&lang=js&"
export * from "./AddDykProductDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports